import { Space } from './Spaces.types';

/** Test Data To Render Starred Space Widget  */
export const mockStarredSpaces: Space[] = [
  {
    id: '1',
    name: 'Biomedicine',
    date: '2024-2025',
  },
  {
    id: '2',
    name: '5053AAD - Architectural and Cultural Critiques ',
    date: '2024-2025',
  },
  {
    id: '3',
    name: '242EMM - Materials and Manufacturing Technology...',
    date: '2023-2024',
  },
  {
    id: '3',
    name: '242EMM - Materials and Manufacturing Technology...',
    date: '2023-2024',
  },
  {
    id: '4',
    name: '242EMM - Materials and Manufacturing Technology...',
    date: '2023-2024',
  },
];
